import type { IDocument } from '@/models/document';

/**
 * Partie lisible du nom d'un document SAV téléchargé (l'extension est
 * recalée ensuite sur le type réel, cf. `utils/fileDownload.ts`).
 * Libellé + nom d'origine quand les deux existent : plusieurs « Photo
 * véhicule » restent distinguables (« Photo véhicule - IMG_1234.jpg »).
 * `fileName` (souvent un uuid) n'est qu'un dernier recours.
 */
export function getDocumentDownloadName(doc: IDocument): string {
  const { label, originalName, fileName } = doc;
  if (label && originalName && !originalName.startsWith(label)) return `${label} - ${originalName}`;
  return label || originalName || fileName || `Document_${doc.id}`;
}
